import React, { useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import AdminStoreDetailsView from './AdminStoreDetailsView';
import { Context as AdminContext } from '../../../providers/AdminContextProvider';
import AdminStoreEscrowPayoutCreateView from './AdminStoreEscrowPayoutCreateView';

const AdminStoreViews = () => {
  const fetchedPkEcomStore = useRef(null);
  const { pkEcomStore } = useParams();
  const { state, fetchEcomStore } = useContext(AdminContext);
  const ecomStoreDetails = state.ecomStore.value;
  const loading =
    !ecomStoreDetails ||
    state.ecomStore.loading ||
    ecomStoreDetails.ecomStore.pkEcomStore.toString() !== pkEcomStore;

  useEffect(() => {
    if (pkEcomStore && pkEcomStore !== fetchedPkEcomStore.current) {
      fetchedPkEcomStore.current = pkEcomStore;
      fetchEcomStore(pkEcomStore);
    }
  }, [pkEcomStore]);

  return (
    <Routes>
      <Route
        element={
          <AdminStoreEscrowPayoutCreateView
            ecomStoreDetails={ecomStoreDetails}
            loading={loading}
          />
        }
        path="escrow/create-payout"
      />
      <Route
        element={
          <AdminStoreDetailsView
            ecomStoreDetails={ecomStoreDetails}
            loading={loading}
          />
        }
        path="/*"
      />
      <Route
        element={<Navigate replace to={`/merchant/stores/${pkEcomStore}`} />}
        path="*"
      />
    </Routes>
  );
};

export default AdminStoreViews;
